<template>
    <div class="time-line">
        <v-dialog v-model="showForm" scrollable>
            <v-card>
                <v-toolbar card prominent color="primary" dark>
                    <v-toolbar-title class="body-2">Registros de asistencia</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cancelForm()">
                        <v-icon medium>fa-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pt-1">
                    <v-card-title class="py-0 actions-filter card-filters">
                        <div class="pb-4 pr-4 font-weight-bold">
                            <v-label>Filtros:</v-label>
                        </div>

                        <v-checkbox
                            v-model="asistencias"
                            label="Asistencias"
                            color="success"
                            class="mt-0"
                            style="max-width: 108px"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="ausenciaJustificada"
                            label="Ausencias justificadas"
                            color="orange"
                            class="mt-0"
                            style="max-width: 110px"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="ausenciaInjustificada"
                            label="Ausencias injustifcadas"
                            color="red"
                            class="mt-0"
                            style="max-width: 100px"
                        ></v-checkbox>

                        <v-spacer></v-spacer>

                        <v-expand-x-transition>
                            <v-daterange
                                v-model="dateRangeCalendar"
                                v-if="dateRangeMenu"
                                start-label="d/m/a"
                                end-label="d/m/a"
                                separator-label="-"
                                preset-label="Prestablecidos"
                                locale="es"
                                display-format="dd/MM/yyyy"
                                label="Rango*"
                                :presets="presets"
                                :input-props="{
                                    style: { width: '245px' },
                                    class: 'mb-1 pa-0'
                                }"
                                :menu-props="{
                                    'z-index': 300
                                }"
                                :action-labels="{
                                    apply: 'Aplicar',
                                    cancel: 'Cancelar',
                                    reset: 'Resetear'
                                }"
                                @input="applyRange"
                            ></v-daterange>
                        </v-expand-x-transition>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    flat
                                    icon
                                    color="grey"
                                    class="mb-4"
                                    :loading="loadingRange"
                                    @click="openCalendarMenu"
                                >
                                    <v-icon medium v-on="on">fa-calendar</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ dateRangeMenu ? "Quitar rango de fecha" : "Establecer rango de fecha" }}</span>
                        </v-tooltip>

                        <v-checkbox
                            v-model="inasistencias"
                            label="Días sin chequear"
                            color="grey"
                            class="mt-0"
                            style="max-width: 100px"
                            @change="setInasistencias"
                        ></v-checkbox>
                        <template v-if="inasistencias">
                            <v-checkbox
                                v-model="inasistenciasSabados"
                                :key="'sabados'"
                                label="Sábados sin chequear"
                                color="grey"
                                class="mt-0"
                                style="max-width: 115px"
                            ></v-checkbox>
                            <v-checkbox
                                v-model="inasistenciasDomingos"
                                :key="'domingos'"
                                label="Domingos sin chequear"
                                color="grey"
                                class="mt-0"
                                style="max-width: 115px"
                            ></v-checkbox>
                        </template>
                    </v-card-title>

                    <v-divider class="pb-2 mt-5"></v-divider>

                    <div class="pl-5">
                        Registros de
                        <span class="font-weight-bold">{{ this.empleado }}</span>
                    </div>

                    <v-divider class="pb-2 mt-1"></v-divider>

                    <h4 v-if="!dataFiltered.length">No existen registros para mostrar</h4>

                    <v-timeline>
                        <v-timeline-item
                            v-for="(registro, i) in dataFiltered"
                            :key="i"
                            small
                            :color="getColor(registro)"
                        >
                            <template v-slot:opposite>
                                <template v-if="registro.tipo !== 'Ausencia'">
                                    <span :class="`headline font-weight-bold`"> {{ registro.fecha }}</span
                                    ><br />
                                    <span :class="`${getColor(registro)}--text`"> {{ registro.tipo }} </span>
                                </template>
                                <template v-else>
                                    <span :class="`headline font-weight-bold`"> {{ registro.fecha }}</span
                                    ><br />
                                    <span :class="`${getColor(registro)}--text`"> {{ registro.tipo }} </span>
                                </template>
                            </template>
                            <v-card v-if="registro.tipo !== 'Ausencia'">
                                <v-card-text class="py-1">
                                    <div>
                                        <div>
                                            Entrada
                                            <v-icon small :disabled="true">fa-clock-o</v-icon>
                                            <span class="font-weight-bold" v-if="registro.entra">{{
                                                registro.entra
                                            }}</span>
                                            <small v-else>sin chequear</small>
                                            <span class="px-2">|</span>
                                            <v-icon small :disabled="true">fa-clock-o</v-icon>
                                            <span class="font-weight-bold" v-if="registro.sale">{{
                                                registro.sale
                                            }}</span>
                                            <small v-else>sin chequear</small>
                                            Salida
                                        </div>
                                        <span v-if="registro.tarde">
                                            Tardanza:
                                            <v-icon small :disabled="true">fa-clock-o</v-icon>
                                            <span class="font-weight-bold">{{ registro.tarde }}</span>
                                        </span>
                                        <div v-if="registro.tipo === 'Ausencia justificada'">
                                            Justificación: {{ getJustificacionDescription(registro.justificacion_id) }}
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                            <v-card v-else>
                                <v-card-text class="py-1">
                                    <div v-if="registro.isSaturday" class="font-weight-bold">
                                        Sábado
                                    </div>
                                    <div v-if="registro.isSunday" class="font-weight-bold">
                                        Domingo
                                    </div>
                                    <span>
                                        No se presentó al trabajo
                                    </span>
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>

                    <v-flex class="icon-load">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-fab-transition>
                                    <v-btn
                                        color="rgba(121, 134, 203, 0.6)"
                                        fab
                                        small
                                        v-show="thereIsNextPage && dataFiltered.length"
                                        dark
                                        :loading="loading"
                                        @click="loadAsistencia()"
                                    >
                                        <v-icon v-on="on">fa-plus</v-icon>
                                    </v-btn>
                                </v-fab-transition>
                            </template>
                            <span>
                                Ver registros anteriores
                                <br />
                                {{
                                    "Página " +
                                        EMPLEADO_ASISTENCIAS_PAG.page +
                                        " de " +
                                        Math.ceil(EMPLEADO_ASISTENCIAS_PAG.total_count / 10)
                                }}
                            </span>
                        </v-tooltip>
                    </v-flex>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" flat @click="cancelForm()">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {
    differenceInDays,
    addDays,
    format,
    isSaturday,
    isSunday,
    subDays,
    getMonth,
    getYear,
    getDaysInMonth
} from "date-fns"
import { VDaterange } from "vuetify-daterange-picker"
import "vuetify-daterange-picker/dist/vuetify-daterange-picker.css"
import { mapGetters } from "vuex"

export default {
    name: "AsistenciaTimeLine",
    components: { VDaterange },
    props: {
        data: { type: Object, default: null }
    },
    data: () => ({
        //todos los registros
        records: [],
        empleado: null,

        //colores de las acciones
        actionColors: ["success", "orange", "red", "grey"],

        //filtros para las acciones
        asistencias: true,
        ausenciaInjustificada: true,
        ausenciaJustificada: true,

        inasistencias: false,
        inasistenciasSabados: false,
        inasistenciasDomingos: false,

        //valores de las justificaciones cargados del servidor
        justificaciones: [],

        //menu para el rango de calendario
        dateRangeMenu: false,
        dateRangeCalendar: { start: "", end: "" },

        //cargando asistencias
        loading: false,
        loadingRange: false
    }),

    computed: {
        showForm: {
            get: function() {
                return true
            },
            set: function() {
                return this.cancelForm()
            }
        },

        dataFiltered() {
            return this.records.filter(
                el =>
                    (this.asistencias && el.tipo === "Asistencia") ||
                    (this.ausenciaInjustificada && el.tipo === "Ausencia injustificada") ||
                    (this.ausenciaJustificada && el.tipo === "Ausencia justificada") ||
                    (this.inasistencias && el.tipo === "Ausencia" && !el.isSaturday && !el.isSunday) ||
                    (this.inasistencias &&
                        this.inasistenciasSabados &&
                        el.tipo === "Ausencia" &&
                        el.isSaturday &&
                        !el.isSunday) ||
                    (this.inasistencias &&
                        this.inasistenciasDomingos &&
                        el.tipo === "Ausencia" &&
                        !el.isSaturday &&
                        el.isSunday)
            )
        },

        //rangos prestablecidos
        presets() {
            if (this.dataFiltered.length) {
                const last30Days = {
                    label: "Últimos 30 días",
                    range: [format(subDays(new Date(), 30), "yyyy-MM-dd"), format(subDays(new Date(), 1), "yyyy-MM-dd")]
                }

                const lastMonth = {
                    label: "Mes anterior",
                    range: [
                        format(new Date(getYear(new Date()), getMonth(new Date()) - 1, 1), "yyyy-MM-dd"),
                        format(
                            new Date(
                                getYear(new Date()),
                                getMonth(new Date()) - 1,
                                getDaysInMonth(new Date(getYear(new Date()), getMonth(new Date()) - 1))
                            ),
                            "yyyy-MM-dd"
                        )
                    ]
                }

                const [sD, sM, sY] = this.dataFiltered[this.dataFiltered.length - 1].fecha.split("/")
                const [eD, eM, eY] = this.dataFiltered[0].fecha.split("/")

                const actualRange = {
                    label: "Rango actual",
                    range: [`${sY}-${sM}-${sD}`, `${eY}-${eM}-${eD}`]
                }

                return [last30Days, lastMonth, actualRange]
            }
            return []
        },

        //paginacion de las asistencias
        ...mapGetters(["EMPLEADO_ASISTENCIAS_PAG"]),

        thereIsNextPage() {
            return (
                this.EMPLEADO_ASISTENCIAS_PAG.total_count >
                this.EMPLEADO_ASISTENCIAS_PAG.page * this.EMPLEADO_ASISTENCIAS_PAG.rowsPerPage
            )
        }
    },

    methods: {
        cancelForm() {
            this.$emit("formCanceled")
        },

        getColor(registro) {
            switch (registro.tipo) {
                case "Asistencia":
                    return this.actionColors[0]
                case "Ausencia justificada":
                    return this.actionColors[1]
                case "Ausencia injustificada":
                    return this.actionColors[2]
                case "Ausencia":
                    return this.actionColors[3]
            }
        },

        getRecordType(record) {
            if (record) {
                if (record.entra && record.sale) {
                    return "Asistencia"
                } else {
                    if (!record.justificacion_id) {
                        return "Ausencia injustificada"
                    }
                    if (record.justificacion_id) {
                        return "Ausencia justificada"
                    }
                }
            }
        },

        setInasistencias() {
            if (this.inasistencias) {
                let new_records = []

                this.records.reverse().forEach((el, index) => {
                    new_records.push(el)

                    if (index < this.records.length - 1) {
                        let [startDay, startMonth, startYear] = el.fecha.split("/")
                        let startTime = new Date(startYear, startMonth - 1, startDay)
                        let [endDay, endMonth, endYear] = this.records[index + 1].fecha.split("/")
                        let endTime = new Date(endYear, endMonth - 1, endDay)

                        if (differenceInDays(endTime, startTime) > 1) {
                            new_records.push(
                                ...this.generateAusenciasDays(startTime, differenceInDays(endTime, startTime) - 1)
                            )
                        }
                    }
                })
                this.records = new_records.reverse()
            }
        },

        generateAusenciasDays(startDate, days) {
            let rangeAusencias = []
            let nextDay = startDate
            for (let i = 0; i < days; i++) {
                nextDay = addDays(nextDay, 1)
                rangeAusencias.push({
                    fecha: format(nextDay, "dd/MM/yyyy"),
                    tipo: "Ausencia",
                    isSaturday: isSaturday(nextDay),
                    isSunday: isSunday(nextDay)
                })
            }
            return rangeAusencias
        },

        getJustificacionDescription(id) {
            if (!this.justificaciones.length) {
                return id
            } else {
                const index = this.justificaciones.findIndex(el => el.id === id)
                if (index !== -1) {
                    return this.justificaciones[index].descripcion
                } else return id
            }
        },

        openCalendarMenu() {
            if (this.dateRangeMenu) {
                this.dateRangeMenu = false
                this.dateRangeCalendar = { start: "", end: "" }
            } else {
                this.dateRangeMenu = true
            }
        },

        applyRange() {
            if (this.dateRangeCalendar.start !== "" && this.dateRangeCalendar.end !== "") {
                this.loadingRange = true
                let filter = `rango_fecha=${this.dateRangeCalendar.start} hasta ${this.dateRangeCalendar.end}`

                this.$store.commit("SET_EMPLEADO_ASISTENCIAS_PAG", { page: 1 })
                this.$store
                    .dispatch("LOAD_EMPLEADO_ASISTENCIA", { empleado_id: this.data.id, dateRangeFilter: filter })
                    .then(response => {
                        if (response) {
                            this.records = []
                            let newItem = {}
                            response.forEach(el => {
                                newItem = el
                                newItem.tipo = this.getRecordType(el)
                                this.records.push(newItem)
                            })
                            this.setInasistencias()
                        }
                        this.loadingRange = false
                    })
            }
        },

        loadAsistencia() {
            if (this.thereIsNextPage) {
                this.loading = true

                let filter = ""
                if (this.dateRangeCalendar.start !== "" && this.dateRangeCalendar.end !== "") {
                    filter = `rango_fecha=${this.dateRangeCalendar.start} hasta ${this.dateRangeCalendar.end}`
                }

                this.$store.commit("SET_EMPLEADO_ASISTENCIAS_PAG", { page: this.EMPLEADO_ASISTENCIAS_PAG.page + 1 })
                this.$store
                    .dispatch("LOAD_EMPLEADO_ASISTENCIA", { empleado_id: this.data.id, dateRangeFilter: filter })
                    .then(response => {
                        if (response) {
                            let newItem = {}
                            response.forEach(el => {
                                newItem = el
                                newItem.tipo = this.getRecordType(el)
                                this.records.push(newItem)
                            })
                            this.setInasistencias()
                        }
                        this.loading = false
                    })
            }
        }
    },

    mounted() {
        this.records = []
        this.empleado = `${this.data.nombre} ${this.data.apellido_paterno} ${this.data.apellido_materno}`
        let newItem = {}
        this.data.asistencia.forEach(el => {
            newItem = el
            newItem.tipo = this.getRecordType(el)
            this.records.push(newItem)
        })

        this.$store.dispatch("LOAD_ALL_RECORDS_JUSTIFICACIONES").then(data => {
            if (data) {
                this.justificaciones = this.$store.getters.JUSTIFICACIONES
            }
        })
    }
}
</script>

<style>
.actions-filter {
    height: 42px;
}
.actions-filter .v-label {
    font-size: 12px !important;
}

.actions-filter .material-icons {
    font-size: 20px !important;
}

.icon-load {
    position: fixed;
    bottom: 80px;
    right: calc(85vw / 2);
}

.icon-load .v-btn--floating.v-btn--small:hover {
    height: 50px;
    width: 50px;
    background: rgba(121, 134, 203, 1) !important;
}

.card-filters {
    position: absolute;
    background-color: rgba(179, 212, 252, 0.6);
    z-index: 100;
    height: 46px;
    width: calc(97% - 8px);
}

.card-filters:hover {
    background-color: rgb(179, 212, 252);
}
</style>
